module.exports = __webpack_public_path__ + "img/todo1.1c758392.svg";